__turbopack_context__.v({
  "mandatory": "Label-module-scss-module__atc53G__mandatory",
  "root": "Label-module-scss-module__atc53G__root",
});
